import * as actionTypes from '@/redux/new_store_structure/actions/actionsTypes';

const initialState = {
	loading: false,
	error: null,
	list: [],
	current: {},
};

export default function notifications(state = initialState, action) {
	switch (action.type) {
		// after START action set LOADING clear ERR
		case actionTypes.NOTIFICATIONS_START:
			return {
				...state,
				loading: true,
				errors: null,
			};
		// if response FAILED set ERR and clear LOADING
		case actionTypes.NOTIFICATIONS_FAILED:
			return {
				...state,
				loading: false,
				errors: action.payload.errors,
			};
		// 	SUCCEED response below:
		// 	on SUCCEED clear ERR and LOADING, set RESPONSE:
		case actionTypes.NOTIFICATIONS_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				list: action.payload,
			};
		case actionTypes.NOTIFICATIONS_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				current: action.payload,
			};
		case actionTypes.NOTIFICATIONS_DETAILS_CLEAR:
			return {
				...state,
				loading: false,
				error: null,
				current: {},
			};
		case actionTypes.NOTIFICATIONS_DELETE_SUCCESS:
			return {
				...state,
				error: null,
				list: state.list.filter(el => el.alertId !== action.payload.id),
			};
		case actionTypes.NOTIFICATIONS_ADD_EDIT_SUCCESS:
			return {
				...state,
				error: null,
				loading: false,
				list: state.list.map(el =>
					el.alertId === action.payload.alertId
						? { ...el, ...action.payload }
						: el,
				),
			};
		case actionTypes.AUTH_LOGOUT:
			return initialState;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/reducers/notifications.js